const validateCarPrice = ({ carPrice, downPayment, minCarPrice, maxCarPrice, minLoanAmount }) => {
    const priceDiff = carPrice - downPayment
    if (priceDiff < minLoanAmount || carPrice < minCarPrice || carPrice > maxCarPrice) return false
    return true
}

const validateDownPayment = ({ carPrice, downPayment, minDownPayment}) => {
    if (downPayment >= carPrice) return false
    if (downPayment < minDownPayment) return false
    return true
}

export {
    validateCarPrice,
    validateDownPayment
}